import React from 'react';
import ResolveHeader from 'components/ResolveHeader';
import VendorQualifications from 'providers/VendorQualification/VendorQualifications.provider';
import { Outlet } from 'react-router-dom';
import { ReactComponent as ResolveLogoSvg } from 'icons/Resolve.svg';
import { useTranslation } from 'react-i18next';
import HelmetWrapper from 'components/HelmetWrapper';
import { getResolveUrl } from 'utils';

import './VendorQualification.styles.scss';
import './VendorQualification.styles.responsive.scss';

const VendorQualification: React.FC = () => {
  const { t } = useTranslation();

  const helmetUrl = getResolveUrl('/vendor-qualification');
  const title = 'Sell your Business the Easy Way | Resolve';
  const description =
    'Thinking of selling your business someday? Resolve can help show you the way.';

  return (
    <div className="vendor-qualification">
      <HelmetWrapper title={title} description={description} url={helmetUrl} />

      <ResolveHeader />
      <header className="mobile-header">
        <a href="/" aria-label="Resolve logo">
          <ResolveLogoSvg />
        </a>
        <p>{t('sellYourBusiness')}</p>
      </header>
      <main>
        <VendorQualifications>
          <Outlet />
        </VendorQualifications>
      </main>
    </div>
  );
};

export default VendorQualification;
